var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfferupScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientTransform: "translate(100 100) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#106d6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19aa81"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.82253,11.38909c18.78499-2.12302,37.56996-2.12302,56.35494,0,5.49081.62055,9.8129,4.94264,10.43345,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35493-.62055,5.49081-4.94265,9.8129-10.43346,10.43345-18.78498,2.12301-37.56995,2.12301-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43346-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35492.62055-5.49081,4.94265-9.8129,10.43345-10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.12329,51.96375c-.93768,7.12109-6.89008,12.60461-14.09271,12.60461-7.85498,0-14.22186-6.52313-14.22186-14.56836s6.36688-14.56836,14.22186-14.56836c7.34534,0,13.38605,5.70093,14.14026,13.0191l5.36804-5.49713,5.12341,5.24573c-.90375-13.13464-11.58539-23.50372-24.63171-23.50372-13.64429,0-24.70642,11.32715-24.70642,25.30438s11.06213,25.30438,24.70642,25.30438c13.09387,0,23.80273-10.43701,24.64526-23.63281l-5.13019-5.25928-5.42236,5.55145Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferupScraper);
export default __webpack_public_path__ + "static/media/offerup-scraper.2f9bfe754a74773e3ece502871cc8735.svg";
export { ForwardRef as ReactComponent };